module.exports = __webpack_public_path__ + "static/fonts/PorscheNext-Bold.e69e8530.otf";